import http from '@/http'

const PATH = '/customers'

function getPath (customerId) {
    return `${PATH}/${customerId}/authentication/accounts`
}

export default {
    /**
     * @param {{customer_id: number, params: {}}} data
     * @returns {Promise<{}>}
     */
    async listMfa ({ customer_id, params }) {
        try {
            const response = await http.get(getPath(customer_id), { params })
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{customer_id: number, account_name: string, secret_key: string}} data
     * @returns {Promise<{}>}
     */
    async createMfa (data) {
        try {
            const response = await http.post(
                getPath(data.customer_id),
                {
                    account_name: data.ACCOUNT_NAME,
                    secret: data.SECRET_KEY
                })
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{customer_id: number, uuid: string}} data
     * @returns {Promise<string>}
     */
    async removeMfa ({customer_id, uuid}) {
        try {
            const response = await http.delete(`${getPath(customer_id)}/${uuid}`)
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}
